// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__cP9ya","sendOtp":"AuthorizeToLogin_sendOtp__33UXi"};